module.exports = __webpack_public_path__ + "83199d0dc841e8c4fa391ef4f59818ef.svg";